module.exports = __webpack_public_path__ + "img/galery-gafas-1.04e56fd2.jpg";